
import { defineComponent } from 'vue';
import * as _ from "lodash";

export default defineComponent({
  props: ['preferredCasing'],
  data() {
      return {
        casings: [                
                { "id" : 0, "label" : "Source Default", "value" : "Default" },
                { "id" : 3, "label" : "UPPER CASE", "value" : "Upper" },
                { "id" : 1, "label" : "lower case", "value" : "Lower" },
                { "id" : 2, "label" : "Sentence case", "value" : "Sentence" },
                { "id" : 4, "label" : "Title Case", "value" : "Title" },
            ]
      }
  },
computed: {
    chunks() {
        return _.chunk(Object.values(this.casings), 2);
    }
  }
});
